import { FormToggleButtonRadioGroup } from '../../../FormToggleButtonRadioGroup';

export type ChartFilter<T extends string> = {
  value: T;
  label: string;
};

type ChartFiltersProps<T extends string> = {
  filters: ChartFilter<T>[];
  selectedValue: T;
  onSelect: (value: T) => void;
};

export const ChartFilters = <T extends string>({
  filters,
  selectedValue,
  onSelect,
}: ChartFiltersProps<T>) => {
  return (
    <FormToggleButtonRadioGroup
      className="bg-base-bg-secondary text-base-text-tertiary rounded-lg msq-toggle-button-group-sm"
      options={filters}
      value={selectedValue}
      onValueChange={onSelect}
      wrapperClassName="max-sm-msq:w-full"
    />
  );
};
